import * as actions from '../constants/actions';

interface IInitialState {
  error: Error | undefined;
  success: boolean | undefined;
}

const initialState: IInitialState = {
  error: undefined,
  success: undefined
};

function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case actions.CONTACT_FULFILLED:
      return {
        ...state,
        error: undefined,
        success: true
      };

    case actions.CONTACT_REJECTED:
      return {
        ...state,
        error: payload
      };

    case actions.RESET_CONTACT_MESSAGES:
      return {
        ...state,
        error: undefined,
        success: undefined
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/contactForm.ts